export function parseQuery(input) {
    const map = Object.create(null);
    if (!input) {
        return map;
    }

    if (input[0] === '?') {
        input = input.slice(1);
    }

    // TODO: this could use `new URLSearchParams(input).forEach()` but it's
    // missing from old Firefox.
    const args = input.split('&');
    const keysAndValues = args.map(arg => arg.split('='));

    keysAndValues.forEach(keyAndValue => {
        const key = decodeURIComponent(keyAndValue[0].replace(/\+/g, ' '));
        const value =
            keyAndValue[1] == null
                ? ''
                : decodeURIComponent(keyAndValue[1].replace(/\+/g, ' '));
        if (!map[key]) {
            map[key] = [];
        }
        map[key].push(value);
    });

    return map;
}

export function serializeQuery(map) {
    const url = new URLSearchParams();
    // This is sorted for better cache hit rate
    Object.entries(map)
        .sort((entry1, entry2) => entry1[0].localeCompare(entry2[0]))
        .forEach(([key, values]) => {
            values.forEach(value => {
                url.append(key, value);
            });
        });
    return url.toString();
}



// WEBPACK FOOTER //
// ./lib/urlQuery.js